// extracted by mini-css-extract-plugin
module.exports = {"header":"MainLayout_header__3bigm","logo":"MainLayout_logo__39R8H","title":"MainLayout_title__2SAsU","content":"MainLayout_content__3mA2z","mainCard":"MainLayout_mainCard__26kFU"};